var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgScanAvailable(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.62702 12.4746V26.3051C1.62702 29.4508 4.17614 32 7.32195 32H24.6779C27.8236 32 30.3728 29.4509 30.3728 26.3051V12.4746H1.62702ZM22.9423 18.6034L15.2948 26.1966C15.0236 26.4678 14.6982 26.5763 14.3186 26.5763C13.9389 26.5763 13.6135 26.4136 13.3423 26.1966L9.00333 21.9119C8.46095 21.3695 8.46095 20.5017 9.00333 20.0136C9.5457 19.4712 10.4135 19.4712 10.9016 20.0136L14.2643 23.3762L20.9355 16.7051L20.9898 16.7593C21.5321 16.2712 22.3457 16.2712 22.8881 16.7593C23.4304 17.1932 23.4846 18.061 22.9423 18.6034ZM24.6778 3.79662H24.1355V1.35594C24.1355 0.596625 23.5389 0 22.7796 0C22.0203 0 21.4236 0.596625 21.4236 1.35594V3.79662H10.5761V1.35594C10.5761 0.596625 9.97958 0 9.2202 0C8.46089 0 7.86427 0.596625 7.86427 1.35594V3.79662H7.32189C4.17614 3.79662 1.62695 6.34575 1.62695 9.49156V9.76275H30.3727V9.49156C30.3728 6.34575 27.8236 3.79662 24.6778 3.79662Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScanAvailable);
export default __webpack_public_path__ + "static/media/scan-available.1d989fe15eac76632391ffa3edffb814.svg";
export { ForwardRef as ReactComponent };